let receivedTotalNavHeight: number = 0;

// Function to compute the navigation height
function computeNavHeight(): number {
    const secondaryNavElement = document.querySelector('.secondary-nav');
    const primaryNavElement = document.querySelector('.main-nav');
    const secondaryNavHeight: number = secondaryNavElement ? secondaryNavElement.getBoundingClientRect().height : 0;
    const primaryNavHeight: number = primaryNavElement ? primaryNavElement.getBoundingClientRect().height : 0;

    return window.innerWidth < 1200 ? secondaryNavHeight : primaryNavHeight;
}

// Function to handle scrolling behavior for navigation
function handleNavScroll(navId: string, positionFromTop: number) {
    const navLinks = document.querySelectorAll(`${navId} .nav-link`);
    const onScroll = () => {
        let currentActive: Element | null = null;
        const overviewLink = Array.from(navLinks).find(link => link.getAttribute('href') === '#overview');
        currentActive = overviewLink;
        navLinks.forEach(link => {
            const target = document.querySelector(link.getAttribute('href') as string) as HTMLElement;
            if (target) {
                const rect = target.getBoundingClientRect();
                let currentThreshold = positionFromTop;
                if (rect.top <= currentThreshold) {
                    currentActive = link;
                }
            }
        });
        navLinks.forEach(link => link.classList.remove('active'));
        if (currentActive) {
            currentActive.classList.add('active');
        }
    };

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onScroll);
    onScroll();
}

// Function to check if the page is at the bottom
function checkIfBottomPage() {
    const applyButton = document.querySelector('.scroll-nav-wrapper .btn-apply');
    const subscribeInput = document.querySelector('.subscribe-wrapper form input') as HTMLInputElement;
    const scrollHeight = document.documentElement.scrollHeight;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const clientHeight = document.documentElement.clientHeight;

    if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
        if (applyButton) {
            applyButton.classList.add('reached-bottom');
        }
        if (subscribeInput) {
            subscribeInput.focus();
        }
    } else {
        if (applyButton) {
            applyButton.classList.remove('reached-bottom');
        }
    }
}

window.addEventListener('load', checkIfBottomPage);
window.addEventListener('scroll', checkIfBottomPage);

document.addEventListener('DOMContentLoaded', function () {
    receivedTotalNavHeight = computeNavHeight();  // Compute immediately upon DOMContentLoaded
    handleNavScroll('#scroll-nav-mobile', receivedTotalNavHeight + 59);
    handleNavScroll('#scroll-nav', receivedTotalNavHeight + 144);
    handleNavScroll('#side-nav', receivedTotalNavHeight + 144);

    document.addEventListener('navHeightUpdated', (e: CustomEvent) => {
        receivedTotalNavHeight = e.detail;
        handleNavScroll('#scroll-nav-mobile', receivedTotalNavHeight + 59);
        handleNavScroll('#scroll-nav', receivedTotalNavHeight + 144);
        handleNavScroll('#side-nav', receivedTotalNavHeight + 144);
    });
});